import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '../../services/http/auth.service';
import { TwoFactorService } from '../../components/two-factor-popup/two-factor.service';
import { TwoFactorDialogComponent } from 'src/app/components/two-factor-popup/two-factor-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class TwoFactorGuard implements CanActivate {
  constructor(private authService: AuthService, private twoFactorService: TwoFactorService, private dialog: MatDialog, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.authService.is2FAVerified()) {
      return true;
    }

    localStorage.setItem('pendingRoute', route.url.join('/'));

    const dialogRef = this.dialog.open(TwoFactorDialogComponent, {
        width: '450px',
        disableClose: true,
      });
    return false;
  }
}
